var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDashboardBg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1711,
    height: 1566,
    viewBox: "0 0 1711 1566",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_3_397)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M858.5 500C1221.63 500 1516 705.053 1516 958C1516 1210.95 1197.63 939.5 834.5 939.5C471.373 939.5 201 1210.95 201 958C201 705.053 495.373 500 858.5 500Z",
    fill: "url(#paint0_angular_3_397)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_3_397",
    x: -299,
    y: 0,
    width: 2315,
    height: 1565.82,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 250,
    result: "effect1_foregroundBlur_3_397"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_angular_3_397",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(858.5 958) scale(657.5 458)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0001,
    stopColor: "#297FFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21875,
    stopColor: "#BF38FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.520833,
    stopColor: "#CF68FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.744792,
    stopColor: "#28CBFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E1A2FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardBg);
export default __webpack_public_path__ + "static/media/Dashboard-bg.772789bd0bfa3226a60d93fb5af03b85.svg";
export { ForwardRef as ReactComponent };